// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5312 ? "940c3aa4" : chunkId) + "." + {"1110":"7117c889beb74909","5312":"a7eb73b9a9bf2ecc"}[chunkId] + ".js";
};